export const items = [
    { value: "Facilitate the connection between hospitals and doctors. Manage appointment scheduling and consultations." },
    { value: "Process payments and invoices." },
    { value: "Enhance the platform through analytics and marketing initiatives." }
  ]; 